export default __webpack_public_path__ + "static/media/logo.cf86ded2.webp";